import { render, staticRenderFns } from "./EditDesignation.vue?vue&type=template&id=7964b7e7&"
import script from "./EditDesignation.vue?vue&type=script&lang=js&"
export * from "./EditDesignation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7964b7e7')) {
      api.createRecord('7964b7e7', component.options)
    } else {
      api.reload('7964b7e7', component.options)
    }
    module.hot.accept("./EditDesignation.vue?vue&type=template&id=7964b7e7&", function () {
      api.rerender('7964b7e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hrmanagement/EmployeeManagement/EditDesignation.vue"
export default component.exports